import * as React from 'react'
import { compose, pure } from 'recompose'

import LargeTitle from '../../atoms/LargeTitle/LargeTitle'
import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'

import * as styles from './QuestionTitle.css'

interface QuestionTitleProps {
  index: number
  title: string
}

const QuestionTitle: React.FunctionComponent<QuestionTitleProps> = ({ index, title }) => (
  <div>
    <TextLabel color={ColorType.MODEST} weight={WeightType.NORMAL} size={SizeType.TINY}>{`第${index + 1}問`}</TextLabel>
    <div className={styles.title}>
      <LargeTitle size={SizeType.TINY}>{title}</LargeTitle>
    </div>
  </div>
)

export default compose<QuestionTitleProps, QuestionTitleProps>(pure)(QuestionTitle)
